module.exports = __webpack_public_path__ + "static/og_disease-6898d5e34a44bd2b2cca8be0e2762108.jpg";